<template>
    <div class="col-sm-12">
        <div>
            <span class="ix-text-bold">Escompte</span>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="is_discount" id="is_discount_false" value="0" v-model="isDiscount">
                <label class="form-check-label" for="is_discount_false">Non</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="is_discount" id="is_discount_true" value="1" v-model="isDiscount">
                <label class="form-check-label" for="is_discount_true">Oui</label>
            </div>
        </div>
        <div class="col-sm-12" v-if="isDiscount == 1 && discountables && discountables.length > 0">
            <div class="ix-table-box mt-2">
                <table class="ix-table">
                    <tbody>
                        <tr v-for="(discount, index) in discountables" :key="index">
                            <td>
                                <input type="hidden" :name="'discounts[' + index + '][id]'" v-model="discount.id">
                                <div class="input-group input-group-sm">
                                    <input type="number" :name="'discounts[' + index + '][day]'" v-model="discount.day" required min="0" step="0.01" class="form-control text-center">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">Jours</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="input-group input-group-sm">
                                    <input type="number" :name="'discounts[' + index + '][percent]'" v-model="discount.percent" required min="0" step="0.01" class="form-control text-center">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <span class="btn btn-sm transparent" @click="deleteDiscount(index)"><i class="far fa-trash"></i></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button type="button" class="ix-btn link" @click="addDiscount"><i class="far fa-plus"></i> Nouvelle ligne</button>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'DiscountTrade',
        props : ['oldDiscountables', 'oldIsDiscount'],
        data(){
            return {
                discountables: [],
                loading: false,
                isDiscount: 0,
            }
        },
        watch: {
            isDiscount(newValue) {
                if (newValue == 0) {
                    this.discountables = [];
                } else if (newValue == 1 && this.discountables.length === 0) {
                    this.addDiscount();
                }
            }
        },
        methods: {
            addDiscount: function(discount){
                var data = {
                    id: null,
                    percent: null,
                    day: null,
                }
                if(discount != null){
                    data.id = discount.id;
                    data.percent = discount.percent;
                    data.day = discount.day;
                }

                this.discountables.push(data);
            },
            deleteDiscount: function(index){
                this.discountables.splice(index, 1)
                if (this.discountables.length == 0 && this.isDiscount == 1) {
                    this.addDiscount()
                }
            }
        },
        async mounted() {
            this.isDiscount = this.oldIsDiscount;
            const jsonDiscountablesBackup = JSON.parse(this.oldDiscountables)

            if (Array.isArray(jsonDiscountablesBackup)) {
                jsonDiscountablesBackup.forEach(discount => {
                    this.addDiscount(discount)
                })
            }
        }
    }
</script>